
var numberHelper = (function () {
  function numberToCurrency (number) {
    if (!number) return 'N/A'
    let amount = parseFloat(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    return '$' + amount.toString()
  }

  return {
    numberToCurrency:   numberToCurrency
  }
})()

export default numberHelper



// WEBPACK FOOTER //
// ./src/helpers/numberHelper.js